/**
 * Feature flag — prontuário (clinical records).
 *
 * Baked at build time from REACT_APP_HEALTH_RECORDS_ENABLED. Unlike the other
 * flags this one defaults to DISABLED: health records are sensitive personal
 * data under the LGPD, and the module stays dark until the compliance programme
 * around it exists. The code is kept whole so turning it back on is one variable.
 *
 * This is UX only. The enforcement is server-side and shares the same name:
 * business-service refuses to turn healthMode on, and clinical-service refuses
 * every request, so a hidden control is never the only thing standing in the way.
 *
 * Every other prontuário surface (Clientes, Calendário, Serviços, Categorias)
 * already renders behind the business's healthMode, which can no longer become
 * true, so only the two controls that CREATE that state read this flag: the
 * onboarding question and the settings toggle.
 */
export const HEALTH_RECORDS_ENABLED: boolean =
    (process.env.REACT_APP_HEALTH_RECORDS_ENABLED ?? 'false').toLowerCase() === 'true';
